import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useActions} from "../../hook/useActions";
import {useTypedSelector} from "../../hook/useTypedSelector";


const AstrologicalDiary = () => {
    const [searchParams] = useSearchParams();
    const date = searchParams.get("date") as string;
    const [text, setText] = useState<string>("");

    const {t} = useTranslation();
    const {GetDiary, AddDiary, DeleteDiary} = useActions();

    const {diary, loading} = useTypedSelector((state) => state.diary);
    const {isAuth, user} = useTypedSelector((store) => store.user);

    useEffect(() => {
        document.title = t("Calendar.Page title");
    }, []);

    useEffect(() => {
        GetDiary(date);
    }, [date]);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setText(event.target.value);
    };

    const handleAddClick = async () => {
        try {
            if (diary) {
                await DeleteDiary(diary.id)
            }
            await AddDiary({id: 0, date: date, text: text});
            GetDiary(date);
        } catch {
            alert("Smth Went Wrong");
        }
    }

    const handleDeleteClick = async () => {
        try {
            await DeleteDiary(diary.id)
            GetDiary(date);
        } catch {
            alert("Smth Went Wrong");
        }
    }

    return (
        <div className={"container col-md-6 mt-4"}>
            {(diary && !loading &&
                <p style={{background: "#DEEBF7", whiteSpace: "pre-wrap"}}>{diary.text}</p>
            )}
            {!diary && !loading &&
                <p style={{background: "#DEEBF7"}}>{t("Calendar.NoAstroData")}</p>
            }
            {(isAuth && user.role.includes("Astrologer") &&
                <div>
                    <div className="row justify-content-between m-lg-4">
                        <button className="btn btn-success col-md-5" onClick={handleAddClick}>
                            add
                        </button>

                        {diary && !loading &&
                            <button className="btn btn-danger col-md-5" onClick={handleDeleteClick}>
                                delete
                            </button>}
                    </div>
                    <textarea
                        value={text}
                        onChange={handleChange}
                        placeholder="Type here..."
                        rows={20}
                        style={{width: "100%"}}
                    />
                </div>
            )}
        </div>
    )
}

export default AstrologicalDiary;